import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
import format from 'date-fns/format'
import addMonths from 'date-fns/add_months';
import addDays from 'date-fns/add_days';
import {globalfunc} from '../globalfunc.js'
import moment from 'moment';
import CryptoJS from 'crypto-js'
export default {
    namespaced: true,
    state: {
      datachart: [],
      dataAll: [],
      datateam:{},
      reviewActivity:{completed:0,pending:0,overdue:0},
      avg:{cultuerAdd:0,GoalsProgress:0,Both:0},
      ChartGoalandCuture:{4:{1:0,2:0,3:0,4:0,},
      3:{1:0,2:0,3:0,4:0,},
      2:{1:0,2:0,3:0,4:0,},
      1:{1:0,2:0,3:0,4:0,},
      mex:0},
      tableData:[],
      receiver:[],
      tableDataAll:[],
      reviewActivityOri:{completed:0,pending:0,overdue:0},
      tableDataOri:[],
      avgOri:{cultuerAdd:0,GoalsProgress:0,Both:0},
      ChartGoalandCutureOri:{4:{1:0,2:0,3:0,4:0,},
      3:{1:0,2:0,3:0,4:0,},
      2:{1:0,2:0,3:0,4:0,},
      1:{1:0,2:0,3:0,4:0,},
      mex:0},
      lineChartOri:[],
      organization:[],
      statussSort:false,
      sortBy:'',
      team:[],
      statusTeam:false,
      valueTeam:'',
      loading:true,
      presetlist:[],
      organization1level:{},
      memberInteam:{},
      memberInteamAll:{},
      presetlistAll:[],
      allUser:[],
      member:[],
      loading_preset:false,
      memberInteamAll_master:{},
      organization1level_master:{}
    },
    mutations: {
      setOrganization(state: any, value: any) {
        state.organization = value
      },
      setdataAll(state: any, value: any) {
        state.dataAll = value
      },
      setdatachart(state: any, value: any) {
        state.datachart = value
      },
      setdatateam(state: any, value: any) {
        state.datateam = value
      },
      setreviewActivity(state: any, value: any) {
        state.reviewActivity = value
      },
      setavg(state: any, value: any) {
        state.avg = value
      },
      setChartGoalandCuture(state: any, value: any) {

        state.ChartGoalandCuture = value
      },
      settableData(state: any, value: any) {
        state.tableData = value
      },
      settableDataAll(state: any, value: any) {
        state.tableDataAll = value
      },
      setloading(state: any, value: any) {
        state.loading = value
      },
      setpresetlist(state: any, value: any) {
      
        state.presetlist = value
      },
      setpresetlistAll(state: any, value: any) {
      
        state.presetlistAll = value
      },
      setOrganization1level(state: any, value: any) {
        state.organization1level = value
      },
      setMemberInteam(state: any, value: any) {
        
        state.memberInteam = value
      },
      setMemberInteamAll(state: any, value: any) {
        state.memberInteamAll = value
      },
      setMemberInteamMaster(state: any, value: any) {
        state.memberInteamAll_master = value
      },
      setAllUser(state: any, value: any) {
        state.allUser = value
      },
      setMember(state: any, value: any) {
        state.member = value
      },
      setloading_preset(state: any, value: any) {
        state.loading_preset = value
      },
      setOrganizationMaster(state: any, value: any) {
        state.organization1level_master = value
      },
      
    },
    actions: {
      async getOrganization({commit,rootState,dispatch,state}:any, value:any){
        let result={}
        let data:Array<any>=[]
        await firebase.firestore().collection('organization1level').where("company", "==", rootState.authen.user.company).get()
        .then((querySnapshot)=> {
                querySnapshot.forEach((doc)=> {
                  const team_id=doc.data().team_id
                  result[team_id]=doc.data().parent
                  data.push(doc.data())



                });
                commit('setOrganization', result)
                commit('setOrganizationMaster', data)    
                dispatch('getSendReviewGem',value)
            
            

        });
      },
      async getTeam({commit,rootState,dispatch,state}:any, value:any){
        let result=[{key: 'All Teams', name: 'All Teams'}]
        
        const allteam =(await firebase.database().ref('team').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val() 
        for (const i in allteam) {
                allteam[i].key = i
                allteam[i].value = allteam[i].name
                result.push(allteam[i])
            }
         
            commit('setdatateam', result)
       
      },
      async changeTeam({commit,rootState,dispatch,state}:any, value:any){
        let todayData:any={cultuerAdd:{value:0,total:0},GoalsProgress:{value:0,total:0},Both:{value:0,total:0}}
        const cohortUser=rootState.leaderboards.cohortUser
        let reviewActivity={completed:0,pending:0,overdue:0,total:0}
        let reviewActivity1={completed:0,goal:0,both:0,culture:0}
        let arrData:any={4:{1:0,2:0,3:0,4:0,},
        3:{1:0,2:0,3:0,4:0,},
        2:{1:0,2:0,3:0,4:0,},
        1:{1:0,2:0,3:0,4:0,},
        mex:0}
        let alluser=rootState.main.allUser
        let tableData:Array<any>=[]
        let family:Array<any> =[]
        const avg={cultuerAdd:{value:0,total:0},GoalsProgress:{value:0,total:0},Both:{value:0,total:0}}
        let calavg={cultuerAdd:'',GoalsProgress:'',Both:''}
        const company = (await firebase.database().ref(`/company/${ rootState.authen.user.company}`).once('value')).val()
        let lineChart:any = {cultuerAdd:[],GoalsProgress:[],Both:[],avg:{cultuerAdd:0,GoalsProgress:0,Both:0}}
        let dataChart={cultuerAdd:{},GoalsProgress:{},Both:{}}
        const receiver=state.receiver
        if(value=='All Teams'){
          state.statusTeam=false
          state.valueTeam=''
           reviewActivity=state.reviewActivityOri
           tableData=state.tableDataOri
            arrData=state.ChartGoalandCutureOri
            lineChart=state.lineChartOri
            calavg=state.avgOri

        }

        else{
          state.valueTeam=value
          state.statusTeam=true
          const organization=state.organization
          let team_select={}
          let _boss = await (await firebase.database().ref(`/boss/${ rootState.authen.user.company}`).once('value')).val()
         
          
          if(organization[value]){
            team_select=organization[value]
          }else{
            team_select={[value]:true}
          }
           //console.log('value',value)
          for(const team in team_select){
        
            let boss_select = _.filter(_boss, function(o) { return o.team==team; });
            
            if(boss_select.length>0){
              const _tableData=_.filter(  state.tableDataAll, function (b) {return b.email==boss_select[0].email;});
              tableData.push(..._tableData)
            }
          }
          
          //console.log('tableData',tableData)
          const received=state.receiver
          if(tableData.length>0){
            for(const i in tableData){
              const family=tableData[i].family
              
              for(const key in family){
                reviewActivity.total++
                reviewActivity.completed+=family[key].reviews_status=='Completed'?1:0
                reviewActivity.overdue+=family[key].reviews_status=='Overdue'?1:0
                reviewActivity.pending+=family[key].reviews_status=='Pending'?1:0
                if(family[key].reviews_status=='Completed'||family[key].reviews_status=='Pending'){

                 if(family[key]){
                  if((family[key].goal_Original&&family[key].culture_Original)){
                    arrData[family[key].culture_Original][family[key].goal_Original]++
                  }
                 }
                  
                }
                
                if(received[family[key].email]){
                 
                  for(const key1 in received[family[key].email]){
                    
                    const data=received[family[key].email][key1]
                    
                    const month=format(new Date(data.createdate), 'YYYY-MM')
                    if(format(new Date(data.createdate), 'YYYY-MM-DD')>=format(addDays(new Date(),-30), 'YYYY-MM-DD')){
                      if(data.culture){
                       
                        todayData.cultuerAdd.total++
                        todayData.cultuerAdd.value+=data.culture==4||data.culture==3?100:data.culture==2?50:0
                      }
                      if(data.goal){
                        
                        todayData.GoalsProgress.total++
                        todayData.GoalsProgress.value+=data.goal==4||data.goal==3?100:data.goal==2?50:0
                        
                      }
                      if(data.goal&&data.culture){
                        
                        todayData.Both.total++
                        if((data.culture==3||data.culture==4)&&(data.goal==3||data.goal==4)){
                          todayData.Both.value+=100
                        }else{
                          todayData.Both.value+=0
                        }
                     
                      }
                    }
  
                      if(data.culture){
                        if(!dataChart.cultuerAdd[month]){
                          dataChart.cultuerAdd[month]={value:0,total:0}
                        }
                        dataChart.cultuerAdd[month].total++
                        dataChart.cultuerAdd[month].value+=data.culture==4||data.culture==3?100:data.culture==2?50:0
                      }
                      if(data.goal){
                        if(!dataChart.GoalsProgress[month]){
                          dataChart.GoalsProgress[month]={value:0,total:0}
                        }
                        dataChart.GoalsProgress[month].total++
                        dataChart.GoalsProgress[month].value+=data.goal==4||data.goal==3?100:data.goal==2?50:0
                      }
                      if(data.goal&&data.culture){
                        if(!dataChart.Both[month]){
                          dataChart.Both[month]={value:0,total:0}
                        }
                        dataChart.Both[month].total++
                        if((data.culture==3||data.culture==4)&&(data.goal==3||data.goal==4)){
                          dataChart.Both[month].value+=100
                        }else{
                          dataChart.Both[month].value+=0
                        }
                        
                      }
                    
                
                  }
                }
               
              }

            }
           
          }

          const today={
            cultuerAdd:todayData.cultuerAdd?todayData.cultuerAdd.value/todayData.cultuerAdd.total:0,
            GoalsProgress:todayData.GoalsProgress?todayData.GoalsProgress.value/todayData.GoalsProgress.total:0,
            Both:todayData.GoalsProgress?todayData.Both.value/todayData.Both.total:0
          }
  
          for(let i=6;i>=0;i--){
            const month=format(addMonths(new Date(),-i), 'YYYY-MM')
            avg.cultuerAdd.value+=dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].value:0
            avg.cultuerAdd.total+=dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].total:0
            avg.GoalsProgress.value+=dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].value:0
            avg.GoalsProgress.total+=dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].total:0
            avg.Both.value+=dataChart.Both[month]?dataChart.Both[month].value:0
            avg.Both.total+=dataChart.Both[month]?dataChart.Both[month].total:0
     
            if(i!=0){
              lineChart.cultuerAdd.push(dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].value/dataChart.cultuerAdd[month].total:0)
              lineChart.GoalsProgress.push(dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].value/dataChart.GoalsProgress[month].total:0)
              lineChart.Both.push(dataChart.Both[month]?dataChart.Both[month].value/dataChart.Both[month].total:0)
            }
            if(i==0){
              lineChart.cultuerAdd.push(isNaN(today.cultuerAdd)?0:today.cultuerAdd)
              lineChart.GoalsProgress.push(isNaN(today.GoalsProgress)?0:today.GoalsProgress)
              lineChart.Both.push(isNaN(today.Both)?0:today.Both)
              calavg.cultuerAdd=isNaN(avg.cultuerAdd.value/avg.cultuerAdd.total)?'0':(avg.cultuerAdd.value/avg.cultuerAdd.total).toFixed()
              calavg.GoalsProgress=isNaN(avg.GoalsProgress.value/avg.GoalsProgress.total)?'0':(avg.GoalsProgress.value/avg.GoalsProgress.total).toFixed()
              calavg.Both=isNaN(avg.Both.value/avg.Both.total)?'0':(avg.Both.value/avg.Both.total).toFixed()
            }

          }

          for(const key in arrData){
            for(const key2 in arrData[key]){
              if(arrData[key][key2]>= arrData.mex){
                arrData.mex=arrData[key][key2]
              }
            }
          }

            

        }

        tableData=_.orderBy(tableData, function(dateObj) {return parseInt( dateObj.reviewCompleted)},['desc'])
        //tableData=_.orderBy(tableData, function(dateObj) {return dateObj.firstname},['asc'])
        commit('setreviewActivity',reviewActivity)
        commit('settableData',tableData)
        commit('setChartGoalandCuture',arrData)
        commit('setdatachart',lineChart)
        commit('setavg',calavg)
        if(state.statussSort==true){
     
          dispatch('sortbydata',state.sortBy)
        }

        


      },
      async getSendReviewGem({dispatch,commit,rootState,state}:any, user:any){
        commit('setreviewActivity',{completed:0,pending:0,overdue:0})
        commit('setdatachart',[])
        commit('setavg',{cultuerAdd:0,GoalsProgress:0,Both:0})
        commit('setChartGoalandCuture',{4:{1:0,2:0,3:0,4:0,},
          3:{1:0,2:0,3:0,4:0,},
          2:{1:0,2:0,3:0,4:0,},
          1:{1:0,2:0,3:0,4:0,},
          mex:0})
        commit('settableData',[])
        commit('setloading', true)
        const past7month=format(addMonths(new Date(),-7), 'YYYY-MM')
        const dataAll:Array<any>=[]
        const reviewActivity={completed:0,pending:0,overdue:0,total:0}

        const arrData:any={4:{1:0,2:0,3:0,4:0,},
        3:{1:0,2:0,3:0,4:0,},
        2:{1:0,2:0,3:0,4:0,},
        1:{1:0,2:0,3:0,4:0,},
        mex:0}
        const team=rootState.main.allTeam
        const alluser=_.cloneDeep(rootState.main.allUser)
        let todayData:any={cultuerAdd:{value:0,total:0},GoalsProgress:{value:0,total:0},Both:{value:0,total:0}}
        const company = (await firebase.database().ref(`/company/${ rootState.authen.user.company}`).once('value')).val()
        let lineChart:any = {cultuerAdd:[],GoalsProgress:[],Both:[],avg:{cultuerAdd:0,GoalsProgress:0,Both:0}}
        let dataChart={cultuerAdd:{},GoalsProgress:{},Both:{}}
        firebase.firestore().collection('send_review_gem').where("company", "==", rootState.authen.user.company).where('createdate','>=',`${past7month}-01`).get()
        .then(function (querySnapshot) {
          querySnapshot.forEach((doc) => {
            const data = doc.data()
            data.review_id=doc.id
            let month=format(new Date(data.createdate), 'YYYY-MM')
            dataAll.push(data)
            if(format(new Date(data.createdate), 'YYYY-MM-DD')>=format(addDays(new Date(),-30), 'YYYY-MM-DD')){
              if(data.culture){
               
                todayData.cultuerAdd.total++
                todayData.cultuerAdd.value+=data.culture==4||data.culture==3?100:data.culture==2?50:0
              }
              if(data.goal){
                
                todayData.GoalsProgress.total++
                todayData.GoalsProgress.value+=data.goal==4||data.goal==3?100:data.goal==2?50:0
                
              }
              if(data.goal&&data.culture){
                
                todayData.Both.total++
                if((data.culture==3||data.culture==4)&&(data.goal==3||data.goal==4)){
                  todayData.Both.value+=100
                }else{
                  todayData.Both.value+=0
                }
             
              }
            }
              if(data.culture){
                if(!dataChart.cultuerAdd[month]){
                  dataChart.cultuerAdd[month]={value:0,total:0}
                }
                dataChart.cultuerAdd[month].total++
                dataChart.cultuerAdd[month].value+=data.culture==4||data.culture==3?100:data.culture==2?50:0
              }
              if(data.goal){
                if(!dataChart.GoalsProgress[month]){
                  dataChart.GoalsProgress[month]={value:0,total:0}
                }
                dataChart.GoalsProgress[month].total++
                dataChart.GoalsProgress[month].value+=data.goal==4||data.goal==3?100:data.goal==2?50:0
                
              }
              if(data.goal&&data.culture){
                if(!dataChart.Both[month]){
                  dataChart.Both[month]={value:0,total:0}
                }
                dataChart.Both[month].total++
                if((data.culture==3||data.culture==4)&&(data.goal==3||data.goal==4)){
                  dataChart.Both[month].value+=100
                }else{
                  dataChart.Both[month].value+=0
                }
                //arrData[data.culture][data.goal]++
              }

            
            

          })
          //console.log('dataChart',dataChart)
          const  receiver = _.groupBy(dataAll, function (b) {
            return b.receiver;
          });
          state.receiver=receiver
          for(const emailKey in alluser){
            reviewActivity.total++
            if(receiver[alluser[emailKey].email]){
              const newData =_.orderBy(receiver[alluser[emailKey].email], function(dateObj) {
                return new Date(dateObj.createdate);
              },['desc'])
             
              if(newData){
               
                const lastData = newData[0]
                alluser[emailKey].track=[]
                

                //track
                for(let i=5;i>=0;i--){
                  let track={month:'',track:'',text:'',text1:'',review_id:''}
                  
                  const month=format(addMonths(new Date(),-i), 'YYYY-MM')
                  const findData= _.find(newData, function(o) {
                    return format(new Date(o.createdate), 'YYYY-MM')==month
                  })
                  track.month=format(addMonths(new Date(),-i), 'MMMM YYYY')
                  if(findData){
                    track.review_id=findData.review_id
                    if(findData.goal==4){
                      track.text='Exceeded Goals: '+findData.goal_value
                    }else if(findData.goal==3){
                      track.text='Met Goals: '+findData.goal_value
                    }else if(findData.goal==2){
                      track.text='Partially Goals: '+findData.goal_value
                    }else if(findData.goal==1){
                      track.text='Did not Meet Goals: '+findData.goal_value
                    }

                    if(findData.culture==4){
                      track.text1='Significantly Contributes to Values: '+findData.culture_value
                    }else if(findData.culture==3){
                      track.text1='Consistently Contributes to Values: '+findData.culture_value
                    }else if(findData.culture==2){
                      track.text1='Somewhat Contributes to Values: '+findData.culture_value
                    }else if(findData.culture==1){
                      track.text1='Rarely Contributes to Values: '+findData.culture_value
                    }

                    if((findData.culture==3||findData.culture==4)&&(findData.goal==3||findData.goal==4)){
                      track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_pink_gem_28.png?alt=media&token=fcbe2996-f5b9-4eec-8b4b-aceed3f39a74')
                     
                    }else{
                      track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_gray_gem_28.png?alt=media&token=a37d9466-4c58-410e-8b60-bddeaae43dc0')
                     
                    }
                  }else{
                    track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_blank_gem_28.png?alt=media&token=b4394a16-e4ee-48af-901f-8fb662240c4f')
                    track.text='No performance boost provided this month'
                  }
                  //console.log('track',track)
                  alluser[emailKey].track.push(track)
                }


                if(lastData.goal){
                  
                  if(lastData.goal==4){
                    alluser[emailKey].goalText='Exceeded'
                  }else if(lastData.goal==3){
                    alluser[emailKey].goalText='Met'
                  }else if(lastData.goal==2){
                    alluser[emailKey].goalText='Partially'
                  }else if(lastData.goal==1){
                    alluser[emailKey].goalText='Did not Meet'
                  }
                }
                if(lastData.culture){

                  if(lastData.culture==4){
                    alluser[emailKey].cultureText='Significantly'
                  }else if(lastData.culture==3){
                    alluser[emailKey].cultureText='Consistently'
                  }else if(lastData.culture==2){
                    alluser[emailKey].cultureText='Somewhat'
                  }else if(lastData.culture==1){
                    alluser[emailKey].cultureText='Rarely'
                  }
                }

                              
                const time_peding=company.performance_review&&company.performance_review.pending?company.performance_review.pending:1
                const time_overdue=company.performance_review&&company.performance_review.overdue?company.performance_review.overdue:2
                if(moment(lastData.createdate).isAfter(moment().add(-time_peding,'months'))){
                  reviewActivity.completed++
                  arrData[lastData.culture][lastData.goal]++
                  alluser[emailKey].reviews_status='Completed'

                  alluser[emailKey].goal_Original=lastData.goal
                  alluser[emailKey].goal=lastData.goal==4||lastData.goal==3?100:lastData.goal==2?50:0

                  alluser[emailKey].culture_Original=lastData.culture
                  alluser[emailKey].culture=lastData.culture==4||lastData.culture==3?100:lastData.culture==2?50:0


                  if(lastData.goal&&lastData.culture){
                    if((lastData.culture==3||lastData.culture==4)&&(lastData.goal==3||lastData.goal==4)){
                      alluser[emailKey].both=100
                    }else{
                      alluser[emailKey].both=0
                    }
                  }  


                }else if(moment(lastData.createdate).isAfter(moment().add(-time_overdue,'months'))){
                    reviewActivity.pending++
                    arrData[lastData.culture][lastData.goal]++
                    alluser[emailKey].reviews_status='Pending'

                    alluser[emailKey].goal_Original=lastData.goal
                    alluser[emailKey].goal=lastData.goal==4||lastData.goal==3?100:lastData.goal==2?50:0

                    alluser[emailKey].culture_Original=lastData.culture
                    alluser[emailKey].culture=lastData.culture==4||lastData.culture==3?100:lastData.culture==2?50:0

                    if(lastData.goal&&lastData.culture){
                      if((lastData.culture==3||lastData.culture==4)&&(lastData.goal==3||lastData.goal==4)){
                        alluser[emailKey].both=100
                      }else{
                        alluser[emailKey].both=0
                      }
                    }  

                }else{
                    reviewActivity.overdue++
                    alluser[emailKey].reviews_status='Overdue'
                }
              }else{
                reviewActivity.overdue++
                alluser[emailKey].reviews_status='Overdue'

                alluser[emailKey].track=[]
                alluser[emailKey].goalText=''
                alluser[emailKey].cultureText=''
                alluser[emailKey].both=0
                alluser[emailKey].goal=0
                alluser[emailKey].culture=0

                for(let i=5;i>=0;i--){
                  let track={month:'',track:'',text:'',text1:''}
                  const month=format(addMonths(new Date(),-i), 'YYYY-MM')
                  const findData= _.find(newData, function(o) {
                    return format(new Date(o.createdate), 'YYYY-MM')==month
                  })
                  track.month=format(addMonths(new Date(),-i), 'MMMM YYYY')
                  if(findData){

                    if(findData.goal==4){
                      track.text='Exceeded Goals:'+findData.goal_value
                    }else if(findData.goal==3){
                      track.text='Met Goals:'+findData.goal_value
                    }else if(findData.goal==2){
                      track.text='Partially Goals:'+findData.goal_value
                    }else if(findData.goal==1){
                      track.text='Did not Meet Goals:'+findData.goal_value
                    }

                    if(findData.culture==4){
                      track.text1='Significantly Contributes to Values:'+findData.culture_value
                    }else if(findData.culture==3){
                      track.text1='Consistently Contributes to Values:'+findData.culture_value
                    }else if(findData.culture==2){
                      track.text1='Somewhat Contributes to Values:'+findData.culture_value
                    }else if(findData.culture==1){
                      track.text1='Rarely Contributes to Values:'+findData.culture_value
                    }

                    if((findData.culture==3||findData.culture==4)&&(findData.goal==3||findData.goal==4)){
                      track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_pink_gem_28.png?alt=media&token=fcbe2996-f5b9-4eec-8b4b-aceed3f39a74')
                     
                    }else{
                      track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_gray_gem_28.png?alt=media&token=a37d9466-4c58-410e-8b60-bddeaae43dc0')
                     
                    }
                  }else{
                    track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_blank_gem_28.png?alt=media&token=b4394a16-e4ee-48af-901f-8fb662240c4f')
                    track.text='No performance boost provided this month'
                  }
                  alluser[emailKey].track.push(track)
                }


              }
            }else{
              const time_peding=company.performance_review&&company.performance_review.pending?company.performance_review.pending:1
              const time_overdue=company.performance_review&&company.performance_review.overdue?company.performance_review.overdue:2
              if(moment(alluser[emailKey].createdatetime).isAfter(moment().add(-time_overdue,'months'))){
                reviewActivity.pending++
                alluser[emailKey].reviews_status='Pending'
              }else{
                reviewActivity.overdue++
                alluser[emailKey].reviews_status='Overdue'
              }
              alluser[emailKey].track=[]
                for(let i=5;i>=0;i--){
                  let track={month:'',track:'',text:'',text1:''}
                  track.month=format(addMonths(new Date(),-i), 'MMMM YYYY')
                  track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_blank_gem_28.png?alt=media&token=b4394a16-e4ee-48af-901f-8fb662240c4f')
                  track.text='No performance boost provided this month'
                  alluser[emailKey].track.push(track)
              }
            }
          }

          let tableData:Array<any>=[]
          let family:Array<any> =[]
          let cultuerAdd:number=0
          let reviewCompleted:number=0
          let GoalsProgress:number=0
          let both:number=0
          let boss = _.groupBy(alluser, function (b) {
            return b.boss;
          });
          for(const key in boss){
            family=[]
            GoalsProgress=0
            cultuerAdd=0
            both=0
            reviewCompleted=0
            if(key!='undefined'){
              for(const key2 in boss[key]){                
                boss[key][key2].team_name= team[boss[key][key2].team]&&team[boss[key][key2].team].name?team[boss[key][key2].team].name:'',
                GoalsProgress+=boss[key][key2].goal?boss[key][key2].goal:0
                boss[key][key2].goal_Original=boss[key][key2].goal_Original?boss[key][key2].goal_Original:0
                boss[key][key2].culture_Original=boss[key][key2].culture_Original?boss[key][key2].culture_Original:0
                cultuerAdd+=boss[key][key2].culture?boss[key][key2].culture:0
                reviewCompleted+=boss[key][key2].reviews_status=='Completed'?100:0
                reviewCompleted+=boss[key][key2].reviews_status=='Pending'?100:0
                both+=boss[key][key2].both?boss[key][key2].both:0
                let user_email=boss[key][key2].email
                const ciphertext = CryptoJS.AES.encrypt(user_email, 'performance-summary-report').toString();
                const url = 'https://insights.happily.ai/performance-summary-report/'+encodeURIComponent(ciphertext);
                boss[key][key2].link=url
                
                family.push(boss[key][key2])
              }
              const emailKey=key.replace(/\./g, "||")
              // console.log('alluser[emailKey]s',alluser[emailKey])
              if(alluser[emailKey]){
                tableData.push({
                  profilepic_crop:alluser[emailKey].profilepic_crop?alluser[emailKey].profilepic_crop:'',
                  firstname: alluser[emailKey].firstname? alluser[emailKey].firstname:'',
                  lastname:  alluser[emailKey].lastname? alluser[emailKey].lastname:'',
                  team_name: team[ alluser[emailKey].team]?team[ alluser[emailKey].team].name:'',
                  email:  alluser[emailKey].email? alluser[emailKey].email:'',
                  reviewCompleted:(reviewCompleted/boss[key].length).toFixed(),
                  GoalsProgress:(GoalsProgress/boss[key].length).toFixed(),
                  cultuerAdd:(cultuerAdd/boss[key].length).toFixed(),
                  both:(both/boss[key].length).toFixed(),
                  family:family
                })
              }
              
            }
           
          }

          const avg={cultuerAdd:{value:0,total:0},GoalsProgress:{value:0,total:0},Both:{value:0,total:0}}
          let calavg={cultuerAdd:'',GoalsProgress:'',Both:''}
   
          const today={
            cultuerAdd:todayData.cultuerAdd?todayData.cultuerAdd.value/todayData.cultuerAdd.total:0,
            GoalsProgress:todayData.GoalsProgress?todayData.GoalsProgress.value/todayData.GoalsProgress.total:0,
            Both:todayData.GoalsProgress?todayData.Both.value/todayData.Both.total:0
          }
          for(let i=6;i>=0;i--){
            const month=format(addMonths(new Date(),-i), 'YYYY-MM')
            avg.cultuerAdd.value+=dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].value:0
            avg.cultuerAdd.total+=dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].total:0
            avg.GoalsProgress.value+=dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].value:0
            avg.GoalsProgress.total+=dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].total:0
            avg.Both.value+=dataChart.Both[month]?dataChart.Both[month].value:0
            avg.Both.total+=dataChart.Both[month]?dataChart.Both[month].total:0
            if(i!=0){
              lineChart.cultuerAdd.push(dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].value/dataChart.cultuerAdd[month].total:0)
              lineChart.GoalsProgress.push(dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].value/dataChart.GoalsProgress[month].total:0)
              lineChart.Both.push(dataChart.Both[month]?dataChart.Both[month].value/dataChart.Both[month].total:0)
            }
            
            if(i==0){
              lineChart.cultuerAdd.push(isNaN(today.cultuerAdd)?0:today.cultuerAdd)
              lineChart.GoalsProgress.push(isNaN(today.GoalsProgress)?0:today.GoalsProgress)
              lineChart.Both.push(isNaN(today.Both)?0:today.Both)
              calavg.cultuerAdd=isNaN(avg.cultuerAdd.value/avg.cultuerAdd.total)?'0':(avg.cultuerAdd.value/avg.cultuerAdd.total).toFixed()
              calavg.GoalsProgress=isNaN(avg.GoalsProgress.value/avg.GoalsProgress.total)?'0':(avg.GoalsProgress.value/avg.GoalsProgress.total).toFixed()
              calavg.Both=isNaN(avg.Both.value/avg.Both.total)?'0':(avg.Both.value/avg.Both.total).toFixed()
            }

          }
          for(const key in arrData){
            for(const key2 in arrData[key]){
              if(arrData[key][key2]>= arrData.mex){
                arrData.mex=arrData[key][key2]
              }
            }
          }

          tableData=_.orderBy(tableData, function(dateObj) {return parseInt( dateObj.reviewCompleted)},['desc'])
          //tableData=_.orderBy(tableData, function(dateObj) {return dateObj.firstname},['asc'])
          
          state.reviewActivityOri=reviewActivity
          state.tableDataOri=tableData
          state.ChartGoalandCutureOri=arrData
          state.lineChartOri=lineChart
          state.avgOri=calavg

       
          
          //commit('setreviewActivity',reviewActivity)
          //commit('setdatachart',lineChart)
          //commit('setavg',calavg)
          //commit('setChartGoalandCuture',arrData)
          //commit('settableData',tableData)
          commit('setdataAll',dataAll)
          commit('settableDataAll',tableData)
          commit('setloading', false)
          if(state.statusTeam==true){
            dispatch('changeTeam',state.valueTeam)
          }else{
            commit('setreviewActivity',reviewActivity)
            commit('setdatachart',lineChart)
            commit('setavg',calavg)
            commit('setChartGoalandCuture',arrData)
            commit('settableData',tableData)
            commit('setdataAll',dataAll)
            commit('settableDataAll',tableData)
            commit('setloading', false)

          }
          
    


        })
      },
      async sortbydata({dispatch,commit,rootState,state}:any, value:any){
        state.statussSort=true
        state.sortBy=value
        let tableData=state.tableData
        if(value=='Highest Completion Rate'){
        
          tableData=_.orderBy(tableData, function(dateObj) {return parseInt( dateObj.reviewCompleted)},['desc'])
        }else if(value=='Lowest Completion Rate'){
          
          tableData=_.orderBy(tableData, function(dateObj) {return parseInt(dateObj.reviewCompleted)},['asc'])
        }else if(value=='Highest Goal Progress'){
         
          tableData=_.orderBy(tableData, function(dateObj) {return parseInt(dateObj.GoalsProgress)},['desc'])
        }else if(value=='Lowest Gaol Progress'){
        
          tableData=_.orderBy(tableData, function(dateObj) {return parseInt(dateObj.GoalsProgress)},['asc'])
        }else if(value=='Highest Culture Add'){
     
          tableData=_.orderBy(tableData, function(dateObj) {return parseInt(dateObj.cultuerAdd)},['desc'])
        }else if(value=='Lowest Culture Add'){

          tableData=_.orderBy(tableData, function(dateObj) {return parseInt(dateObj.cultuerAdd)},['asc'])
        }else if(value=='Highest Both'){
  
          tableData=_.orderBy(tableData, function(dateObj) {return parseInt(dateObj.both)},['desc'])
        }else if(value=='Lowest Both'){

          tableData=_.orderBy(tableData, function(dateObj) {return parseInt(dateObj.both)},['asc'])
        }
        commit('settableData',tableData)
      },
      async searchData({dispatch,commit,rootState,state}:any, value:any){
        var re = new RegExp(value, 'gi')
        const tableData = state.statusTeam==true?state.tableData:(state.tableDataAll)
        const _tableData:Array<any> =[]

        let family:Array<any> =[]
        if (value) {
          for(const key in tableData){
            family=[]
            if (tableData[key].firstname.match(re)) {
              _tableData.push(tableData[key])
            } else if (tableData[key].lastname.match(re)) {
              _tableData.push(tableData[key])
            }else{
              for(const key1 in tableData[key].family){
                if (tableData[key].family[key1].firstname.match(re)) {
                  family.push(tableData[key].family[key1])
                } else if (tableData[key].family[key1].lastname.match(re)) {
                  family.push(tableData[key].family[key1]) 
                }
              }
              if(family.length>0){
                _tableData.push({...tableData[key],family:family})
              }
              

            }
            
            
          }
     

          // commit('setrewardsSearch', response)
          commit('settableData', _tableData)
        } else {
          if(state.statusTeam==true){
            dispatch('changeTeam',state.valueTeam)
          }else{
            commit('settableData', state.tableDataAll)
          }
          
        }
      },
    
      async download({dispatch,commit,rootState,state}:any, user:any){
        const past7month=format(addMonths(new Date(),-12), 'YYYY-MM')
        const dataAll:Array<any>=[]
        let _boss =  (await firebase.database().ref(`/boss/${ rootState.authen.user.company}`).once('value')).val()
        const reviewActivity={completed:0,pending:0,overdue:0,total:0}
        // const company = (await firebase.database().ref(`/company/${ rootState.authen.user.company}`).once('value')).val()
        //const team=rootState.main.allTeam
        const alluser=_.cloneDeep(rootState.main.allUser)
        
        firebase.firestore().collection('send_review_gem').where("company", "==", rootState.authen.user.company).where('createdate','>=',`${past7month}-01`).get()
        .then(function (querySnapshot) {
          querySnapshot.forEach((doc) => {
            const data = doc.data()
            dataAll.push(data)
          })
   
          const  receiver = _.groupBy(dataAll, function (b) {
            return b.receiver;
          });
          let family:Array<any> =[]
          for(const emailKey in alluser){
            reviewActivity.total++
            if(receiver[alluser[emailKey].email]){
              const newData =_.orderBy(receiver[alluser[emailKey].email], function(dateObj) {
                return new Date(dateObj.date);
              },['desc'])
              
              if(newData){
                alluser[emailKey].totalData=0
                alluser[emailKey].track=[]
                for(const i in newData){
                  const lastData=newData[i]
                  let goalText=''
                  let cultureText=''
                  if(lastData.goal){

                    if(lastData.goal==4){
                      goalText='Exceeded'
                    }else if(lastData.goal==3){
                     goalText='Met'
                    }else if(lastData.goal==2){
                      goalText='Partially'
                    }else if(lastData.goal==1){
                      goalText='Did not Meet'
                    }
                  }
                  if(lastData.culture){
                    if(lastData.culture==4){
                      cultureText='Significantly'
                    }else if(lastData.culture==3){
                      cultureText='Consistently'
                    }else if(lastData.culture==2){
                      cultureText='Somewhat'
                    }else if(lastData.culture==1){
                      cultureText='Rarely'
                    }
                  }
  
                 
                  const _emailKey=alluser[emailKey].boss.replace(/\./g, "||")
                  if(alluser[_emailKey]&&alluser[emailKey]){
                    family.push({
                      name:alluser[emailKey].firstname+' '+alluser[emailKey].lastname,
                      boss:alluser[_emailKey].firstname+' '+alluser[_emailKey].lastname,
                      email:alluser[emailKey].email,
                      emailboss:alluser[_emailKey].email,
                      createdate:format(new Date(lastData.createdate), 'MMMM YYYY'),
                      reviewCompleted:'Completed',
                      GoalsProgress:goalText,
                      cultuerAdd:cultureText,
                      gem:lastData.gem?lastData.gem==1?'Yes':'Yes (2)':'No',
                      goal_value:lastData.goal_value?lastData.goal_value:'',
                      culture_value:lastData.culture_value?lastData.culture_value:'',
                      month:format(new Date(lastData.createdate), 'MM YYYY'),
                      
                      
                    })

                  }
                  

                }
              }
            }
      
          }

          let tableData:Array<any>=_.cloneDeep(state.tableDataAll)//state.tableDataAll
          if(state.statusTeam==true){
            
            let boss_select = _.filter(_boss, function(o) { return o.team==state.valueTeam; });
            tableData=_.filter( tableData, function (b) {return b.email==boss_select[0].email;});
            family=_.filter( family, function (b) {return b.emailboss==boss_select[0].email;});

          }
          
          tableData=_.orderBy(tableData, function(dateObj) {return dateObj.GoalsProgress},['desc'])
          family=_.orderBy(family, ['name', 'createdate'], ['desc', 'asc'])
          
          dispatch('genDataExport',{manager:tableData,member:family})

        })
      },
      async genDataExport({ commit, state, dispatch, rootState }: any, obj:any) {
        const company = (await firebase.database().ref(`/company/${ rootState.authen.user.company}`).once('value')).val()
        const header:any = ['','Team Name','']
        const manager= obj.manager
        const member= obj.member
        const Excel = require('exceljs');
        var wb = new Excel.Workbook();
        var ws = wb.addWorksheet('Manager Overview');
        var ws1 = wb.addWorksheet('Employee Performance');
        /*TITLE*/
        ws.getRow(2).height = 20
        ws.getCell('A1').font = { name: 'Arial', size: 12, bold: true }
        ws.getCell('A1').alignment = { vertical: 'middle' }
        ws.getCell('A1').value = `${company.name} Performance Review Data Downloaded on ${format(new Date(),'MMMM DD,YYYY')}`

        // /*Column headers*/
        ws.getColumn('A').width = 25;
        ws.getColumn('B').width = 10;
        ws.getColumn('C').width = 10;
        ws.getColumn('D').width = 10;
        ws.getColumn('E').width = 10;
        ws.getRow(3).values =['Manager','Reviews completed','Goal Progress','Culture Add','Both']
        
        // /*Data*/
        _.forEach(manager, (item, key)=> {
          let _tmp = [
            item.firstname+' '+item.lastname,
            item.reviewCompleted,
            item.GoalsProgress,
            item.cultuerAdd,
            item.both,
          
          ];
          ws.addRow(_tmp);
   
        });


        //sheet2
        /*TITLE*/
        ws1.getRow(2).height = 20
        ws1.getCell('A1').font = { name: 'Arial', size: 12, bold: true }
        ws1.getCell('A1').alignment = { vertical: 'middle' }
        ws1.getCell('A1').value = `${company.name} Performance Review Data Downloaded on ${format(new Date(),'MMMM DD,YYYY')}`

        // /*Column headers*/
        ws1.getColumn('A').width = 25;
        ws1.getColumn('B').width = 10;
        ws1.getColumn('C').width = 10;
        ws1.getColumn('D').width = 10;
        ws1.getColumn('E').width = 10;
        ws1.getRow(3).values =['Team Member','Manager','Month Completed','Goal Progress','Feedback','Culture Add','Feedback','Gem Received']
        // /*Data*/
        _.forEach(member, (item, key)=> {
          let _tmp = [
            item.name,
            item.boss,
            item.createdate,
            item.GoalsProgress,
            item.goal_value,
            item.cultuerAdd,
            item.culture_value,
            item.gem,
          
          ];
          ws1.addRow(_tmp);
   
        });

        
        wb.xlsx.writeBuffer( {
          base64: true
        })
        .then( function (xls64) {
            // build anchor tag and attach file (works in chrome)
            var a = document.createElement("a");
            var data = new Blob([xls64], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

            var url = URL.createObjectURL(data);
            a.href = url;
            a.download = 'Performance' + ".xlsx";
            document.body.appendChild(a);
            a.click();
            setTimeout(function() {
               
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(url);
                },
                0);
        })
        .catch(function(error) {
            console.log(error.message);
        });
      },
      async getPresets({commit,state,dispatch,rootState}:any){
        //console.log("getPresets")
        commit('setloading_preset',true)
        let memberInteamAll=_.cloneDeep(state.memberInteamAll_master)
        //console.log("memberInteamAll",memberInteamAll)
        const preset_list:Array<any>=[]
        const team_all=(await firebase.database().ref('team').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
        const user_all=(await firebase.database().ref('users').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
        const boss_all=(await firebase.database().ref(`boss/${rootState.authen.user.company}`).once('value')).val()
        const team_used_preset:Array<any>=[]
        const user_used_preset:Array<any>=[]
        firebase.firestore().collection('performance_template').where("company", "==", rootState.authen.user.company).get()
        .then(async function (querySnapshot) {
          querySnapshot.forEach((doc) => {
            const data = doc.data()
            data.id=doc.id
            data.focus_preset=false
            //console.log("data",data.teams)
            if(data.teams){
              if(!team_used_preset[data.id]){
                team_used_preset[data.id]=[]
              }
              team_used_preset[data.id].push(...data.teams)
            }
            if(data.users){
              if(!user_used_preset[data.id]){
                user_used_preset[data.id]=[]
              }
              user_used_preset[data.id].push(...data.users)
            }
            
            preset_list.push(data)
          })
          const member_groupbyteam:any=_.groupBy(user_all, function (b) {
            return b.team;
          });
          
          
          for(const item of preset_list){
            
            item.total_assignments=0
            item.data_users=[]
            item.data_team=[]
            if(item.users){
              for(const x of item.users){
                const emailKey=x.replace(/\./g, "||")
                const user:any={}
                if(user_all[emailKey]){
                  user.email=user_all[emailKey].email
                  user.firstname=user_all[emailKey].firstname
                  user.lastname=user_all[emailKey].lastname
                  user.boss=user_all[emailKey].boss
                  user.team=user_all[emailKey].team
                  user.team_name=team_all[user_all[emailKey].team]?team_all[user_all[emailKey].team].name:''
                  user.profilepic_crop=user_all[emailKey].profilepic_crop
                  item.data_users.push(user)
                }
                item.total_assignments+=1
                for(const key in memberInteamAll){
                  const _user=_.filter(memberInteamAll[key].users, function(o) { return o.email!==user.email });
                  if(_user&&_user.length>0){
                    //console.log("memberInteamAll",_user)
                    // const _member=_.find(memberInteamAll[key].users, function(o) { return o.email==user.email });
                    _user.preset_name=item.name
                    memberInteamAll[key].users=_user
                  }
                }


              }

            }
            
            if(item.teams){
              for(const team of item.teams){
                
                const organization1level=state.organization1level[team]
                const team_data=team_all[team]
                let memberbyteem=0
                if(organization1level){
                  for(const team_id in organization1level){

                    if(member_groupbyteam[team_id]){
                      for(const user of member_groupbyteam[team_id]){
                        
                        //check user used preset
                        for(const id_preset in user_used_preset){
                          const _finduser=_.find(user_used_preset[id_preset], function(o) { return o==user.email });
                          if(_finduser){
                              user.user_preset_id=id_preset
                              
                          }
                        }
                        for(const id_preset in team_used_preset){
                          const _findteam=_.find(team_used_preset[id_preset], function(o) { return o==user.team });
                            if(_findteam){
                              if(!user.user_preset_id){
                                user.team_preset_id=id_preset
                              }
                              // user team
                              for(const key in memberInteamAll){
                                const _user=_.filter(memberInteamAll[key].users, function(o) { return o.email==user.email });
                                if(_user&&_user.length>0&&key!==user.team){
                                  const _user_team=_.filter(memberInteamAll[key].users, function(o) { return o.email!==user.email });
                                  memberInteamAll[key].users=_user_team
                                  
                             
                                }
                              }

                            }



                          }
                              if(!user.team_preset_id&&!user.user_preset_id){
                             
                                //console.log("id_prese!!!!!!!!!",id_preset)
                                const emailkey_boss=user.boss.replace(/\./g, "||")
                                  
                                const temp_team=boss_all[emailkey_boss].team

                                
                                
                              
                                const checkteam_preset=await dispatch('checkTeamUsed',{user_email:user.email,boss_email:user.boss,team:temp_team,alluser:user_all,boss_all:boss_all,team_used_preset:team_used_preset})
                             

                                
                                  const _user=_.filter(memberInteamAll[team].users, function(o) { return o.email==user.email });
                                  if(_user&&_user.length>0&&team!==(checkteam_preset&&checkteam_preset.team_id)){
                                    const _user_team=_.filter(memberInteamAll[team].users, function(o) { return o.email!==user.email });
                                    memberInteamAll[team].users=_user_team                              
                                  }

                                
                                

                                


                                if(checkteam_preset&&checkteam_preset.id_preset==item.id){
                                  
                                  
                                  memberbyteem+=1
                                  item.total_assignments+=1
                                }
                              }else if(user.team_preset_id==item.id){
                                memberbyteem+=1
                                item.total_assignments+=1

                              }
                          //}

                        }
                    }




                    // }
                  }
                  if(team_data){
                    team_data.membersteams=memberbyteem
                    team_data.id=team
                    item.data_team.push(team_data)
                  }
                }else{
                  const team_data=team_all[team]
                  if(member_groupbyteam[team]){
                    if(team_data){
                      team_data.membersteams=member_groupbyteam[team].length
                      item.total_assignments+=member_groupbyteam[team].length
                      team_data.id=team
                      item.data_team.push(team_data)
                    }
                    
                  }
                  
                }
              }
            }

            
          }
         
          memberInteamAll=_.orderBy(memberInteamAll, 'name', 'asc')
          commit('setMemberInteam',memberInteamAll)
          commit('setMemberInteamAll',memberInteamAll)
          commit('setpresetlistAll',preset_list)
          commit('setpresetlist',preset_list)
          commit('setloading_preset',false)
        })
        
      },
      async getmemberInteam({commit,state,dispatch,rootState}:any, value:any){
        commit('setloading_preset',true)
        const organization1level:any={}
        let user_all=(await firebase.database().ref('users').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
        const group_memberinteam:any=_.groupBy(user_all, function (b) {
          return b.team;
        });
        
        const team_all=(await firebase.database().ref('team').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
        const memberinteam_all:any={}
        let memberinteam:any={}
        const organization1level_master=_.cloneDeep(state.organization1level_master)
        // await firebase.firestore().collection('organization1level').where("company", "==", rootState.authen.user.company).get()
        //     .then((querySnapshot)=> {
        //             querySnapshot.forEach((doc)=> {
                      for(const key in organization1level_master){
                        const data=organization1level_master[key]
                        if(!organization1level[data.team_id]){
                          organization1level[data.team_id]=data.parent
                        }
                        if(!memberinteam_all[data.team_id]){
                          memberinteam_all[data.team_id]={users:[],name:team_all[data.team_id]?team_all[data.team_id].name:'',id:data.team_id}
                        }
                        if(!memberinteam[data.team_id]){
                          memberinteam[data.team_id]={users:[],name:team_all[data.team_id]?team_all[data.team_id].name:'',id:data.team_id}
                        }
                        if(data.parent){
                          for(const key  in data.parent){
                           
                       
                            if(group_memberinteam[key]){
                              memberinteam_all[data.team_id].users.push(...group_memberinteam[key])
                              memberinteam[data.team_id].users.push(...group_memberinteam[key])
                            }
                          }
                          
                        }   

                      }
                    
                                      
                    // });
                    for(const key in team_all){
                      if(!memberinteam_all[key]){
                        if(group_memberinteam[key]){
                          memberinteam_all[key]={users:group_memberinteam[key],name:team_all[key].name,id:key}
                        }
                      }
                      if(!memberinteam[key]){
                        if(group_memberinteam[key]){  
                          memberinteam[key]={users:group_memberinteam[key],name:team_all[key].name,id:key}
                        }
                      }
                    }
                    //console.log("memberinteam",memberinteam)
                    memberinteam=_.orderBy(memberinteam, 'name', 'asc')
                    commit('setOrganization1level', organization1level)
                    commit('setMemberInteam', memberinteam)
                    commit('setMemberInteamMaster', memberinteam_all)
                    commit('setMemberInteamAll', memberinteam_all)
                    for(const key in user_all){
                      user_all[key].team_name=team_all[user_all[key].team].name
                    }
                    user_all=_.orderBy(user_all, 'firstname', 'asc')
                    commit('setAllUser', user_all)
                    commit('setMember', user_all)
                    dispatch('getPresets')
            // });
        
      },
      async updateAndCreatePreset({commit,state,dispatch,rootState}:any, value:any){
        //console.log('updateAndCreatePreset',value)
        commit('setloading_preset',true)
        const preset_form=_.cloneDeep(value.preset)
        const duplicate=_.cloneDeep(value.duplicate)
        
        for(const key in duplicate){
          if(duplicate[key].status_duplicate_team==true&&duplicate[key].status_duplicate_user==true){
            const team:any=[]
            const user:any=[]
            const newId=duplicate[key].id
            if(duplicate[key].team){
              for(const i in duplicate[key].team){
                team.push(duplicate[key].team[i])
              }
            }
            if(duplicate[key].users){
              for(const i in duplicate[key].users){
                user.push(duplicate[key].users[i])
              }
            } 
            const data:any={
              users:user,
              teams:team,
              modified_at:format(new Date(),'YYYY-MM-DD HH:mm:ss')
            }
            await firebase.firestore().collection('performance_template').doc(newId).update(data)

          }
          else if(duplicate[key].status_duplicate_team==true){
            const team:any=[]
            const newId=duplicate[key].id
            if(duplicate[key].team){
              for(const i in duplicate[key].team){
           
                team.push(duplicate[key].team[i])
              }
            }

            const data:any={
              teams:team,
              modified_at:format(new Date(),'YYYY-MM-DD HH:mm:ss')
            }
            await firebase.firestore().collection('performance_template').doc(newId).update(data)
          }else if(duplicate[key].status_duplicate_user==true){
            const user:any=[]
            const newId=duplicate[key].id
            if(duplicate[key].users){
              for(const i in duplicate[key].users){
                user.push(duplicate[key].users[i])
              }
            } 
            const data:any={
              users:user,
              modified_at:format(new Date(),'YYYY-MM-DD HH:mm:ss')
            }
            await firebase.firestore().collection('performance_template').doc(newId).update(data)
          }
        }
        let user:any=[]
        let team:any=[]
        if(preset_form.users){
          for(const i in preset_form.users){
            //console.log("i",i)
            user.push(preset_form.users[i].email)
          }
        }
        if(preset_form.team){
          for(const i in preset_form.team){

            team.push(preset_form.team[i].id)
          }
        }
       // console.log("user",user)
        let newId=''
        const data:any={
          name:preset_form.name,
          users:user,
          company:rootState.authen.user.company,
          goals:preset_form.goals,
          culture:preset_form.culture,
          teams:team,
          modified_by:rootState.authen.user.email,
          next_review:preset_form.next_review,
          status:true,
        }
        if(!preset_form.team){
          delete data.teams
        }
        if(!preset_form.users){
          //console.log("preset_form.users",preset_form.users)
          delete data.users
        }
        
        try {
        if(preset_form.preset_id){

          newId=preset_form.preset_id
          data.modified_at=format(new Date(),'YYYY-MM-DD HH:mm:ss')
          await firebase.firestore().collection('performance_template').doc(newId).update(data)
          //.log('update preset success')
        }else{

          //console.log('create preset')
          data.created_at=format(new Date(),'YYYY-MM-DD HH:mm:ss')
          await firebase.firestore().collection('performance_template').doc().set(data) 
      
          //console.log('create preset success')
        }
        dispatch('getPresets')
        } catch (error) {
          //console.error('Error updating or creating preset:', error)
        }
       
        

      },
      async checkTeamUsed({state,rootState,dispatch}:any, value:any){
        
        const user_all=value.alluser
        const boss_all=value.boss_all
        const user_email=value.user_email
        const boss_email=value.boss_email
        const team_id=value.team
        const team_used_preset=value.team_used_preset
        for(const id_preset in team_used_preset){
          
          if(team_id!=''){
          const _findteam=_.find(team_used_preset[id_preset], function(o) { return o==team_id });
            if(_findteam){
    
              return {id_preset:id_preset,team_id:team_id}
            }
          }
        }
        const emailkey = boss_email.replace(/\./g, "||")
        if (user_all[emailkey] && user_all[emailkey].boss) {
        const emailkey=boss_email.replace(/\./g, "||")
        const temp_boss=user_all[emailkey].boss
        const emailkey_boss=user_all[emailkey].boss.replace(/\./g, "||")
        const temp_team=user_all[emailkey_boss].team
        if (temp_team) {
          return await dispatch('checkTeamUsed',{user_email:user_email,boss_email:temp_boss,team:temp_team,alluser:user_all,boss_all:boss_all,team_used_preset:team_used_preset})
        }
        }
      },
      async deletePreset({commit,state,dispatch,rootState}:any, value:any){
        //console.log('deletePreset',value)
        await firebase.firestore().collection('performance_template').doc(value.preset_id).delete()
        dispatch('getPresets')
      },
      async searchmemberandteamandMember({commit,state,dispatch,rootState}:any, value:any){
        //console.log('searchmemberandteam',value)
        const type=value.type
        let memberinteam:any={}
        var re = new RegExp(value.value, 'gi')
        if(type=='team'){
          
          const _memberinteam:any=_.cloneDeep(state.memberInteamAll)
          if (value.value) {
            for(const key in _memberinteam){
              if(_memberinteam[key].name.match(re)){
                memberinteam[key]=_memberinteam[key]
              }
            }
            //console.log("memberinteam",memberinteam)
            memberinteam=_.orderBy(memberinteam, 'name', 'asc')
            commit('setMemberInteam', memberinteam)
          }else{
            commit('setMemberInteam', state.memberInteamAll)
          }
        }
        else{
          const _memberinteam:any=_.cloneDeep(state.allUser)
          if (value.value) {
            for(const key in _memberinteam){
              //console.log("key",_memberinteam[key].firstname)
              if(_memberinteam[key].firstname.match(re)){
                memberinteam[key]=_memberinteam[key]
              }else if(_memberinteam[key].lastname.match(re)){
                memberinteam[key]=_memberinteam[key]
              }else if(_memberinteam[key].email.match(re)){
                memberinteam[key]=_memberinteam[key]
              }else if(_memberinteam[key].team_name.match(re)){
                memberinteam[key]=_memberinteam[key]
              }
            }
            //console.log("memberinteam",memberinteam)
            memberinteam=_.orderBy(memberinteam, 'firstname', 'asc')
            commit('setMember', memberinteam)
          }else{
            commit('setMember', state.allUser)
          }
        }
      },
      async searchData_preset({commit,state,dispatch,rootState}:any, value:any){
        //.log('searchData_preset',value)
        var re = new RegExp(value, 'gi') 
        const presetlistAll:any=_.cloneDeep(state.presetlistAll)
        //console.log("presetlistAll",presetlistAll)
        const presetlist:any=[]
        if (value) {
          for(const key in presetlistAll){
            //console.log("presetlistAll[key].name",presetlistAll[key].name)
            if(presetlistAll[key].name.match(re)){
              presetlist.push(presetlistAll[key])
            }
            else if(presetlistAll[key].goals.match(re)){
              presetlist.push(presetlistAll[key])
            }
            else if(presetlistAll[key].culture.match(re)){
              presetlist.push(presetlistAll[key])
            }
            else if(presetlistAll[key].next_review.match(re)){
              presetlist.push(presetlistAll[key])
            }
          }
          //console.log("presetlist",presetlist)
         commit('setpresetlist', presetlist)
        }else {
          commit('setpresetlist', presetlistAll)
        }
       
      },
      async deleteReview({commit,state,dispatch,rootState}:any, value:any){
        commit('setloading',true)
        commit('settableData',[])
        
        const gem=value.employeegem-1
        firebase.database().ref(`/users/${value.employeeId}`).update({gem:gem})
        await firebase.firestore().collection('develop_skills').where("review_id","==",value.reviewId).get().then((querySnapshot) => {
          querySnapshot.forEach(async (doc) => {
            //console.log('develop_skills',doc.id,doc.data())
            await firebase.firestore().collection('develop_skills').doc(doc.id).delete()
          })
        })
        await firebase.firestore().collection('spark_class_ai').where("id","==",value.reviewId).get().then((querySnapshot) => {
          querySnapshot.forEach(async (doc) => {
            //console.log('spark_class_ai',doc.id,doc.data())
            await firebase.firestore().collection('spark_class_ai').doc(doc.id).delete()
          })
        })
        await firebase.firestore().collection('messages').where("id_review","==",value.reviewId).get().then((querySnapshot) => {
          querySnapshot.forEach(async (doc) => {
            //console.log('messages',doc.id,doc.data())
            await firebase.firestore().collection('messages').doc(doc.id).delete()
          })
        })
        await firebase.firestore().collection('here_point').where("review_id","==",value.reviewId).get().then((querySnapshot) => {
          querySnapshot.forEach(async (doc) => {
            //console.log('performance_review',doc.id,doc.data())
            await firebase.firestore().collection('here_point').doc(doc.id).delete()
          })
        })
        
        await firebase.firestore().collection('send_review_gem').doc(value.reviewId).delete()
        dispatch('getSendReviewGem',value.team)

      }
    },
    
    getters: {
      datachart : (state:any) => {
        return state.datachart
      },
      reviewActivity: (state:any) => {
        return state.reviewActivity
      },
      avg: (state:any) => {
        return state.avg
      },
      ChartGoalandCuture: (state:any) => {
        return state.ChartGoalandCuture
      },
      tableData: (state:any) => {
        return state.tableData
      },
      team: (state:any) => {
        return state.datateam
      },
      loading: (state:any) => {
        return state.loading
      },
      presetlist: (state:any) => {
        //console.log("state.presetlist",state.presetlist)
        return state.presetlist
      },
      memberInteamAll: (state:any) => {
        return state.memberInteamAll
      },
      memberInteam: (state:any) => {
        return state.memberInteam
      },
      member: (state:any) => {
        return state.member
      },
      loading_preset: (state:any) => {
        return state.loading_preset
      },
      presetlistAll: (state:any) => {
        return state.presetlistAll
      }
    }
  }
